module.exports = __webpack_public_path__ + "img/202408_06.929d8424.jpg";